(() => {
  if (customElements.get('trevi-announcements')) return;
  customElements.define('trevi-announcements', class extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('.trevi-announcement__slide')];
      this.index = 0;
      this.paused = matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.hovered = false;
      this.timer = null;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.pauseButton = this.querySelector('.trevi-announcement__pause');
      this.querySelector('.trevi-announcement__prev')?.addEventListener('click', () => this.show(-1), options);
      this.querySelector('.trevi-announcement__next')?.addEventListener('click', () => this.show(1), options);
      this.pauseButton?.addEventListener('click', () => { this.paused = !this.paused; this.syncPause(); this.schedule(); }, options);
      this.addEventListener('mouseenter', () => { this.hovered = true; this.schedule(); }, options);
      this.addEventListener('mouseleave', () => { this.hovered = false; this.schedule(); }, options);
      this.addEventListener('focusin', () => this.schedule(), options);
      this.addEventListener('focusout', () => queueMicrotask(() => this.schedule()), options);
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      this.syncPause();
      this.schedule();
    }
    syncPause() {
      if (!this.pauseButton) return;
      this.pauseButton.textContent = this.paused ? '▶' : 'Ⅱ';
      this.pauseButton.setAttribute('aria-label', this.paused ? 'Play announcements' : 'Pause announcements');
      this.pauseButton.setAttribute('aria-pressed', String(this.paused));
    }
    show(direction) {
      this.index = (this.index + direction + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, index) => { slide.hidden = index !== this.index; });
      this.schedule();
    }
    schedule() {
      clearTimeout(this.timer);
      if (this.slides.length < 2 || this.paused || this.hovered || document.hidden || this.contains(document.activeElement)) return;
      this.timer = setTimeout(() => this.show(1), Number(this.dataset.interval) || 5000);
    }
    disconnectedCallback() { clearTimeout(this.timer); this.abort.abort(); }
  });
})();
